















import Vue from 'vue'
export default Vue.extend({
  props: {
    width: {
      type: Number
    }
  },
  computed: {
    transform (): string {
      const i = this.width / 2
      return `translate(${i} ${i})`
    }
  },
  mounted () {
    if (this.width === undefined) {
      console.error('[To Developer] attr "width" is required.')
    }
  }
})
